export default "__VITE_ASSET__BQ2Rp19n__"